import { object, string } from "yup"

export default object({
  name: string().required("Required"),
  url: string().required("Required"),
  catchAll: string().email("Invalid email address"),
})
